import { MultiDateConstellationField } from '../../../../constellationExtended/MultiDatePicker/MultiDateConstellationField';
import { Label } from '@zillow/constellation';
import React from 'react';
import { useFormikContext } from 'formik';
import { IOrderParams } from '../../../../API/pcDashboard/getOrderAsync';

export const ClosingDateFilter: React.FC = () => {
  const {
    initialValues: { closingDateStart, closingDateEnd },
  } = useFormikContext<IOrderParams>();
  return (
    <MultiDateConstellationField
      key={`${closingDateStart}-${closingDateEnd}`}
      startName={'closingDateStart'}
      endName={'closingDateEnd'}
      label={<Label>Closing Date</Label>}
    />
  );
};
